export const RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED'
